const assignEmployeesBehavior = async (source, content, parentContentPath, transientContext, nativeFunctions, sourceEvaluator) => {
  const {
    selection = {},
    content: {
      employees = {}
    }
  } = transientContext;
  const formTypeIdentifiers = Object.keys(selection);
  for (let i = 0; i < formTypeIdentifiers.length; i += 1) {
    const formTypeIdentifier = formTypeIdentifiers[i];
    const formIDs = selection[formTypeIdentifier];
    for (let j = 0; j < formIDs.length; j += 1) {
      // eslint-disable-next-line no-await-in-loop
      await sourceEvaluator({
        type: 'patchContentBehavior',
        id: formIDs[j],
        patches: [{
          assignedEmployees: employees
        }]
      });
    }
  }
  const numEmployees = Object.keys(employees).length;
  const addedString = numEmployees === 1 ? '1 employee' : `${numEmployees} employees`;
  await sourceEvaluator({
    type: 'alertBehavior',
    message: `${addedString} assigned.`,
    options: [{
      title: 'OK'
    }]
  });
};
module.exports = {
  evaluate: assignEmployeesBehavior
};